import { SelectableBox } from '@components/SelectableBox'
import { Box } from '@mui/material'
import { useCallback } from 'react'

enum ProductImportMode {
	MANUAL,
	BULK,
	NONE,
}

interface IProps {
	mode: ProductImportMode
	setMode: (type: ProductImportMode) => void
	children?: React.ReactElement
	acceptsPactImport?: boolean
}

const AddProductModeSelector = ({
	mode,
	setMode,
	children,
	acceptsPactImport,
}: IProps) => {
	const onSelect = useCallback(
		() => setMode(ProductImportMode.MANUAL),
		[setMode]
	)

	const onSelectBulk = useCallback(
		() => setMode(ProductImportMode.BULK),
		[setMode]
	)

	return (
		<Box display="flex" flexDirection="column" gap={1} justifyContent="center">
			{children}
			<Box display="flex" gap={3} mt={2}>
				<SelectableBox
					translationContext="scratch"
					onSelect={onSelect}
					selected={mode === ProductImportMode.MANUAL}
				/>
				<SelectableBox
					translationContext={acceptsPactImport ? 'bulk_pact' : 'bulk'}
					onSelect={onSelectBulk}
					selected={mode === ProductImportMode.BULK}
				/>
			</Box>
		</Box>
	)
}

export { AddProductModeSelector, ProductImportMode }
